export const STEPS = {
  // in most cases these are the steps, but might have to tweak
  step1: 'step1', // form
  step2: 'step2', // review
  step3: 'step3', // hello sign
};

export const stateForms = {
  alabama: 'Form A-4',
  alaska: '',
  arizona: 'Form A-4',
  arkansas: 'Form AR4EC',
  california: 'Form DE 4',
  colorado: 'Form W-4',
  connecticut: 'Form CT-W4',
  district_of_columbia: 'Form D-4',
  delaware: 'Form DE-W4',
  florida: '',
  georgia: 'Form G-4',
  hawaii: 'Form HW-4',
  idaho: 'Form ID W-4',
  illinois: 'Form IL-W-4',
  indiana: 'Form WH-4',
  iowa: 'Form IA W-4',
  kansas: 'Form K-4',
  kentucky: 'Form K-4',
  louisiana: 'Form L-4',
  maine: 'Form W-4ME',
  maryland: 'Form MW507',
  massachusetts: 'Form M-4',
  michigan: 'Form MI-W4',
  minnesota: 'Form W-4MN',
  mississippi: 'Form 89-350-19-3',
  missouri: 'Form MO W-4',
  montana: 'Form MW-4',
  nebraska: 'Form W-4N',
  nevada: '',
  new_hampshire: '',
  new_jersey: 'Form NJ-W4',
  new_mexico: 'Form W-4',
  new_york: 'Form IT-2104',
  north_carolina: 'Form NC-4',
  north_dakota: 'Form W-4',
  ohio: 'Form IT-4',
  oklahoma: 'Form OK-W-4',
  oregon: 'Form OR-W-4',
  pennsylvania: 'Form REV-419',
  rhode_island: 'Form RI W-4',
  south_carolina: 'Form SC W-4',
  south_dakota: '',
  tennessee: '',
  texas: '',
  utah: 'Form W-4',
  vermont: 'Form W-4VT',
  virginia: 'Form VA-4',
  washington: '',
  west_virginia: 'Form WV/IT-104',
  wisconsin: 'Form WT-4',
  wyoming: '',
};

export const stateOptions = [
  { codeValue: 'AL', shortName: 'Alabama' },
  { codeValue: 'AK', shortName: 'Alaska' },
  { codeValue: 'AZ', shortName: 'Arizona' },
  { codeValue: 'AR', shortName: 'Arkansas' },
  { codeValue: 'CA', shortName: 'California' },
  { codeValue: 'CO', shortName: 'Colorado' },
  { codeValue: 'CT', shortName: 'Connecticut' },
  { codeValue: 'DE', shortName: 'Delaware' },
  { codeValue: 'DC', shortName: 'District of Columbia' },
  { codeValue: 'FL', shortName: 'Florida' },
  { codeValue: 'GA', shortName: 'Georgia' },
  { codeValue: 'HI', shortName: 'Hawaii' },
  { codeValue: 'ID', shortName: 'Idaho' },
  { codeValue: 'IL', shortName: 'Illinois' },
  { codeValue: 'IN', shortName: 'Indiana' },
  { codeValue: 'IA', shortName: 'Iowa' },
  { codeValue: 'KS', shortName: 'Kansas' },
  { codeValue: 'KY', shortName: 'Kentucky' },
  { codeValue: 'LA', shortName: 'Louisiana' },
  { codeValue: 'ME', shortName: 'Maine' },
  { codeValue: 'MD', shortName: 'Maryland' },
  { codeValue: 'MA', shortName: 'Massachusetts' },
  { codeValue: 'MI', shortName: 'Michigan' },
  { codeValue: 'MN', shortName: 'Minnesota' },
  { codeValue: 'MS', shortName: 'Mississippi' },
  { codeValue: 'MO', shortName: 'Missouri' },
  { codeValue: 'MT', shortName: 'Montana' },
  { codeValue: 'NE', shortName: 'Nebraska' },
  { codeValue: 'NV', shortName: 'Nevada' },
  { codeValue: 'NH', shortName: 'New Hampshire' },
  { codeValue: 'NJ', shortName: 'New Jersey' },
  { codeValue: 'NM', shortName: 'New Mexico' },
  { codeValue: 'NY', shortName: 'New York' },
  { codeValue: 'NC', shortName: 'North Carolina' },
  { codeValue: 'ND', shortName: 'North Dakota' },
  { codeValue: 'OH', shortName: 'Ohio' },
  { codeValue: 'OK', shortName: 'Oklahoma' },
  { codeValue: 'OR', shortName: 'Oregon' },
  { codeValue: 'PA', shortName: 'Pennsylvania' },
  { codeValue: 'RI', shortName: 'Rhode Island' },
  { codeValue: 'SC', shortName: 'South Carolina' },
  { codeValue: 'SD', shortName: 'South Dakota' },
  { codeValue: 'TN', shortName: 'Tennessee' },
  { codeValue: 'TX', shortName: 'Texas' },
  { codeValue: 'UT', shortName: 'Utah' },
  { codeValue: 'VT', shortName: 'Vermont' },
  { codeValue: 'VA', shortName: 'Virginia' },
  { codeValue: 'WA', shortName: 'Washington' },
  { codeValue: 'WV', shortName: 'West Virginia' },
  { codeValue: 'WI', shortName: 'Wisconsin' },
  { codeValue: 'WY', shortName: 'Wyoming' },
];

export const stateNamesAndForms = {
  AL: {
    name: 'alabama',
    form: 'Alabama state tax withholding: Form A-4',
    link: 'https://www.revenue.alabama.gov/ultraviewer/viewer/basic_viewer/index.html?form=2021/10/A4_201403.pdf',
  },
  AR: {
    name: 'arkansas',
    form: 'Arkansas state tax withholding: Form AR4EC',
    link: 'https://www.dfa.arkansas.gov/images/uploads/incomeTaxOffice/AR4EC.pdf',
    link11_17_2021:
      'https://www.dfa.arkansas.gov/images/uploads/incomeTaxOffice/AR4EC2021_FI.pdf',
  },
  AZ: {
    name: 'arizona',
    form: 'Arizona state tax withholding: Form A-4',
    link: 'https://azdor.gov/file/10832/download?token=zT28PPOA',
    link2022: 'https://azdor.gov/file/12159/download?token=LgbLMUdE',
    link2024: 'https://azdor.gov/sites/default/files/2023-12/FORMS_WITHHOLDING_2024_A-4.pdf',
    link2025: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/az_a4_05.pdf',
  },
  CA: {
    name: 'california',
    form: 'California state tax withholding: Form DE 4',
    link: 'https://www.edd.ca.gov/pdf_pub_ctr/de4.pdf',
  },
  CO: {
    name: 'colorado',
    form: 'Colorado state tax withholding: Form W-4',
    link: 'https://www.irs.gov/newsroom/faqs-on-the-2020-form-w-4',
    link2024: 'https://www.irs.gov/pub/irs-pdf/fw4.pdf',
  },
  CT: {
    name: 'connecticut',
    form: 'Connecticut state tax withholding: Form CT-W4',
    link: 'https://portal.ct.gov/-/media/DRS/Forms/2021/WTH/CT-W4_1220.pdf',
    link12_21:
      'https://portal.ct.gov/-/media/DRS/Forms/2022/WTH/CT-W4_1221.pdf',
    link12_23:
      'https://portal.ct.gov/-/media/DRS/Forms/2024/WTH/CT-W4_1223.pdf',
    link12_24:
      'https://check-api-static-production.s3.amazonaws.com/forms/pdf/ct_w4_05.pdf',
  },
  DC: {
    name: 'district-of-columbia',
    form: 'District of Columbia state tax withholding: Form D-4',
    link: 'https://www.justice.gov/crt/page/file/1335666/download',
    link10_17: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/dc_d4_01.pdf',
  },
  DE: {
    name: 'delaware',
    form: 'Delaware state tax withholding: Form DE-W4',
    link: 'https://revenuefiles.delaware.gov/2021/DE-W4.pdf',
  },
  GA: {
    name: 'georgia',
    form: 'Georgia state tax withholding: Form G-4',
    link: 'https://dor.georgia.gov/document/form/tsdemployeeswithholdingallowancecertificateg-4pdf/download',
  },
  HI: {
    name: 'hawaii',
    form: 'Hawaii state tax withholding: Form HW-4',
    link: 'https://files.hawaii.gov/tax/forms/2021/hw4_i.pdf',
    linkhi_2022: 'https://files.hawaii.gov/tax/forms/2022/hw4_i.pdf',
  },
  IA: {
    name: 'iowa',
    form: 'Iowa state tax withholding: Form IA W-4',
    link: 'https://tax.iowa.gov/forms/ia-w-4-employees-withholding-certificate-44-019-23',
    link11_28_2023: 'https://tax.iowa.gov/sites/default/files/2023-12/2024IAW-4(44019)_0.pdf',
    link11_18_2024: 'https://revenue.iowa.gov/media/4059/download?inline',
  },
  ID: {
    name: 'idaho',
    form: 'Idaho state tax withholding: Form ID W-4',
    link: 'https://tax.idaho.gov/document-mngr/forms_EFO00307',
    link12_18_2023: 'https://tax.idaho.gov/wp-content/uploads/forms/EFO00307/EFO00307_12-18-2023.pdf',
  },
  IL: {
    name: 'illinois',
    form: 'Illinois state tax withholding: Form IL-W-4',
    link: 'https://tax.illinois.gov/content/dam/soi/en/web/tax/forms/withholding/documents/currentyear/il-w-4.pdf',
  },
  IN: {
    name: 'indiana',
    form: 'Indiana state tax withholding: Form WH-4',
    link: 'https://forms.in.gov/Download.aspx?id=2702',
  },
  KS: {
    name: 'kansas',
    form: 'Kansas state tax withholding: Form K-4',
    link: 'https://www.ksrevenue.org/pdf/k-4.pdf',
  },
  KY: {
    name: 'kentucky',
    form: 'Kentucky state tax withholding: Form K-4',
    link: 'https://revenue.ky.gov/Forms/K-4%2042A804%20(2021)(9-20).pdf',
    link11_23: 'https://revenue.ky.gov/Forms/42A804(K-4)%20(2).pdf',
    link11_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/ky_k4_05.pdf',
  },
  LA: {
    name: 'louisiana',
    form: 'Louisiana state tax withholding: Form L-4',
    link: 'http://revenue.louisiana.gov/TaxForms/1300(4_11)F.pdf',
  },
  MA: {
    name: 'massachusetts',
    form: 'Massachusetts state tax withholding: Form M-4',
    link: 'https://www.mass.gov/doc/form-m-4-massachusetts-employees-withholding-exemption-certificate/download',
  },
  ME: {
    name: 'maine',
    form: 'Maine state tax withholding: Form W-4ME',
    link: 'https://www.maine.gov/nrsc/forms/2020%20-%20Maine%20W4.pdf',
    link12_23: 'https://www.maine.gov/revenue/sites/maine.gov.revenue/files/inline-files/24_form_w-4me_ff_1.pdf',
    link12_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/me_w4me_05.pdf',
  },
  MD: {
    name: 'maryland',
    form: 'Maryland state tax withholding: Form MW507',
    link: 'https://www.marylandtaxes.gov/forms/current_forms/mw507.pdf',
    link05_23: 'https://www.marylandtaxes.gov/forms/24-forms/MW507.pdf',
    link03_23: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/md_mw507_03.pdf',
  },
  MI: {
    name: 'michigan',
    form: 'Michigan state tax withholding: Form MI-W4',
    link: 'https://www.michigan.gov/documents/taxes/MI-W4_370050_7.pdf',
  },
  MN: {
    name: 'minnesota',
    form: 'Minnesota state tax withholding: Form W-4MN',
    link: 'https://www.revenue.state.mn.us/sites/default/files/2021-01/w-4mn.pdf',
    link2022:
      'https://www.revenue.state.mn.us/sites/default/files/2021-12/w-4mn_0.pdf',
    link2024:
      'https://www.revenue.state.mn.us/sites/default/files/2023-12/w-4mn.pdf',
    link2025:
      'https://check-api-static-production.s3.amazonaws.com/forms/pdf/mn_w4mn_05.pdf',
  },
  MO: {
    name: 'missouri',
    form: 'Missouri state tax withholding: Form MO W-4',
    link: 'https://dor.mo.gov/forms/MO%20W-4.pdf',
  },
  MS: {
    name: 'mississippi',
    form: 'Mississippi state tax withholding: Form 89-350-19-3',
    link: 'https://www.msnd.uscourts.gov/sites/msnd/files/forms/MS%20Employee%27s%20Withholding%20Exemption%20Certificate.pdf',
    link8_20:
      'https://www.msnd.uscourts.gov/sites/msnd/files/forms/MS%20witholding%20Form.pdf',
    link11_23: 'https://www.dor.ms.gov/sites/default/files/Business/89350238.pdf',
    link8_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/ms_89350_06.pdf',
  },
  MT: {
    name: 'montana',
    form: 'Montana state tax withholding: Form MW-4',
    link: 'https://app.mt.gov/myrevenue/Endpoint/DownloadPdf?yearId=871',
    linkmt_2023: 'https://mtrevenue.gov/wp-content/uploads/dlm_uploads/2023/12/MW-4.pdf',
  },
  NE: {
    name: 'nebraska',
    form: 'Nebraska state tax withholding: Form W-4N',
    link: 'https://revenue.nebraska.gov/files/doc/tax-forms/f_w4.pdf',
  },
  NC: {
    name: 'north-carolina',
    form: 'North Carolina state tax withholding: Form NC-4',
    link: 'https://www.ncdor.gov/tax-forms/nc-4-employees-withholding-allowance-certificate/open',
    link9_20: 'https://files.nc.gov/ncdor/documents/files/NC-4-Web_0.pdf',
    link11_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/nc_nc4_05.pdf',
  },
  ND: {
    name: 'north-dakota',
    form: 'North Dakota state tax withholding: Form W-4',
    link: 'https://www.irs.gov/newsroom/faqs-on-the-2020-form-w-4',
    link2024: 'https://www.irs.gov/pub/irs-pdf/fw4.pdf',
  },
  NJ: {
    name: 'new-jersey',
    form: 'New Jersey state tax withholding: Form NJ-W4',
    link: 'https://www.state.nj.us/treasury/taxation/pdf/current/njw4.pdf',
  },
  NM: {
    name: 'new-mexico',
    form: 'New Mexico state tax withholding: Form W-4',
    link: 'https://www.irs.gov/newsroom/faqs-on-the-2020-form-w-4',
    link2024: 'https://www.irs.gov/pub/irs-pdf/fw4.pdf',
  },
  NY: {
    name: 'new-york',
    form: 'New York state tax withholding: Form IT-2104',
    link: 'https://www.tax.ny.gov/pdf/current_forms/it/it2104_fill_in.pdf',
  },
  OH: {
    name: 'ohio',
    form: 'Ohio state tax withholding: Form IT 4',
    link: 'https://tax.ohio.gov/static/forms/employer_withholding/generic/wth_it4.pdf',
    link12_20:
      'https://tax.ohio.gov/static/forms/employer_withholding/generic/wth-it4-combined-fi.pdf',
    link1_24:
      'https://check-api-static-production.s3.amazonaws.com/forms/pdf/oh_it4_02.pdf',
  },
  OR: {
    name: 'oregon',
    form: 'Oregon state tax withholding: Form OR-W-4',
    link: 'https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4_101-402_2024.pdf',
    link08_23: 'https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4_101-402_2024.pdf',
    link08_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/or_w4_05.pdf',
    link09_22: 'https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4_101-402_2023.pdf',
    link8_20:
      'https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4_101-402_2021.pdf',
    link11_19: 'https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4_101-402_2020.pdf',
  },
  OK: {
    name: 'oklahoma',
    form: 'Oklahoma state tax withholding: Form OK-W-4',
    link: 'https://oklahoma.gov/content/dam/ok/en/tax/documents/forms/businesses/general/OK-W-4.pdf',
  },
  RI: {
    name: 'rhode-island',
    form: 'Rhode Island state tax withholding: Form RI W-4',
    link: 'https://tax.ri.gov/sites/g/files/xkgbur541/files/2024-01/2024%20RI%20W-4_w.pdf',
    linkri_2025: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/ri_w4_05.pdf',
    linkri_2024: 'https://tax.ri.gov/sites/g/files/xkgbur541/files/2024-01/2024%20RI%20W-4_w.pdf',
    linkri_2022: 'https://tax.ri.gov/media/17996/download?language=en',
    linkri_2021: 'http://controller.admin.ri.gov/documents/Forms/Payroll%20Forms/505_2021%20W-4%20Form%20RI%20State.pdf',
  },
  SC: {
    name: 'south-carolina',
    form: 'South Carolina state tax withholding: Form SC-W4',
    link: 'https://dor.sc.gov/forms-site/Forms/SCW4_2021.pdf',
    link10_25_21: 'https://dor.sc.gov/forms-site/Forms/SCW4_2022.pdf',
    link11_30_23: 'https://dor.sc.gov/forms-site/Forms/SCW4_2024.pdf',
    link11_21_24: 'https://check-api-static-production.s3.amazonaws.com/forms/pdf/sc_w4_05.pdf',
  },
  UT: {
    name: 'utah',
    form: 'Utah state tax withholding: Form W-4',
    link: 'https://www.irs.gov/newsroom/faqs-on-the-2020-form-w-4',
    link2024: 'https://www.irs.gov/pub/irs-pdf/fw4.pdf',
  },
  VA: {
    name: 'virginia',
    form: 'Virginia state tax withholding: Form VA-4',
    link: 'https://www.tax.virginia.gov/sites/default/files/taxforms/withholding/any/va-4-any.pdf',
  },
  VT: {
    name: 'vermont',
    form: 'Vermont state tax withholding: Form W-4VT',
    link: 'https://tax.vermont.gov/sites/tax/files/documents/W-4VT.pdf',
  },
  WI: {
    name: 'Wisconsin',
    form: 'Wisconsin state tax withholding: Form WT-4',
    link: 'https://www.revenue.wi.gov/TaxForms2017through2019/w-204f.pdf',
    link8_23: 'https://www.revenue.wi.gov/TaxForms2017through2019/w-204f.pdf',
  },
  WV: {
    name: 'west-virginia',
    form: 'West Virginia state tax withholding: Form WV/IT-104',
    link: 'https://tax.wv.gov/Documents/Withholding/it104.pdf',
  },
  PA: {
    name: 'pennsylvania',
    form: 'Pennsylvania state tax withholding: Form REV-419',
    link: 'https://www.revenue.pa.gov/FormsandPublications/FormsforBusinesses/EmployerWithholding/Documents/rev-419.pdf',
  },
};
